import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { StoreModule } from "@karma-games/angular-devkit/src/lib/extended-store";
import "./store/round.extensions";
import { RoundState } from "./store/interfaces";
import { roundReducer } from "./store/round.reducers";


@NgModule({
    declarations: [],
    providers: [
    ],
    imports: [
        CommonModule,
        StoreModule.forFeature(RoundState.featureKey, roundReducer)
    ]
})
export class RoundModule {
}
